module.exports = __webpack_public_path__ + "img/PR4-F.0ac9ffb2.png";